var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":_vm.close}},'v-btn',attrs,false),[_vm._v(" 閉じる ")])]}}]),model:{value:(_vm.item.active),callback:function ($$v) {_vm.$set(_vm.item, "active", $$v)},expression:"item.active"}},[_vm._v(" "+_vm._s(_vm.item.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }